import instance from './http'
import url from './url'

export default {
  // sso
  userLogin: (params) => instance.post(url.userLogin, params),
  // url 使用post的进行params的方式
  getCardUser: () => instance.get(url.getCardUser),
  getUserRegional: () => instance.get(url.GetUserRegional),
  uploadUserAvatar: (params) => instance.post(url.uploadAvator, params),
  checkUserProto: () => instance.get(url.checkProto),
  getWhiteList: () => instance.get(url.getWhiteList),
  getAiaOrganList: () => instance.get(url.AiaOrganList),
  getUserExtraInfo: (params) => instance.get(url.UserExtraInfo(params)),
  setSaveExtraInfo: (params) =>
    instance.post(url.SaveExtraInfo(params), params),
  postInMemberCard: (params) => instance.post(url.isInMemberCard, params),
}
